import { Checkbox } from '@/component';

export function LabeledCheckbox({ name, title, subtext, value, onChange }) {
  return (
    <label>
      <Checkbox name={name} value={value} onChange={onChange} />
      <span className="space-y-1.5">
        <span className="text-slate-800 text-[16px] leading-[12px] font-medium text-left">
          {title}
        </span>
        <div className="text-slate-500 text-sm leading-[10px]">{subtext}</div>
      </span>
    </label>
  );
}
